import Vue from 'vue'

const defRouter = {
  state: {
    defRouters: []
  },
  mutations: {
    setDefRouters: (state, routers) => {
      state.defRouters = routers
    }
  },
  getters: {
    getDefRouters: state => state.defRouters
  },
  actions: {

  }
}

export default defRouter
